import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { StoreSearchDTO } from '../../../../shared/store-search-dto';

@Injectable({
  providedIn: 'root'
})
export class StoreSearchService {

  constructor(private http: HttpClient) { }

  getItems(term: string): Observable<StoreSearchDTO[]> {
    return this.http.post<StoreSearchDTO[]>(`/api/product/storesearch`, { term })
  }
}
